import { Modal, Form, Button } from '@themesberg/react-bootstrap'
import { ErrorMessage, Formik } from 'formik'
import React from 'react'
import { reasonSchema } from './schema'
import { AffiliateStatus } from './constants'
import { updateAffiliateStatusStart } from '../../../store/redux-slices/superAdminSettings'

const AffiliateApprovalRejectionForm = ({
  show,
  handleClose,
  selectedUser,
  dispatch,
  page,
  limit,
  fromUsers
}) => {
  console.log(selectedUser);
  return (
    <>
      <Formik
        initialValues={{
          reason: '',
          status: ''
        }}
        validationSchema={reasonSchema}
        onSubmit={(formValues, { resetForm }) => {
          let payload = {
            ...formValues,
            userId: selectedUser?.userId,
            affiliateId: selectedUser?.affiliateId
          }

          console.log(payload)
          dispatch(updateAffiliateStatusStart({
            data: payload,
            limit: limit,
            pageNo: page,
            status: fromUsers ? 'APPROVED' : '',
            affiliiateUser: fromUsers ? true : false
          }))
          resetForm({ formValues: '' })
          handleClose()
        }}
      >
        {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
          <Modal
            show={show}
            onHide={handleClose}
            backdrop='static'
            keyboard={false}
          >
            <Modal.Header closeButton>
              <h5>Update {selectedUser?.username || 'Player'}  Affiliate Status</h5>
            </Modal.Header>
            <Modal.Body>
              <div className='form-group'>
                <label
                  htmlFor='reason'
                  className={touched.status && errors.status ? 'text-danger' : ''}
                >
                  Status<span className='text-danger'> *</span>
                </label>
                <Form.Select
                  name='status'
                  value={values.status}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={touched.status && errors.status ? 'border border-danger' : ''}
                >
                  <option value=''>Select Affiliate Status</option>
                  {AffiliateStatus.map(reason => <option value={reason.value} key={reason.value}>{reason.label}</option>)}
                </Form.Select>
                <ErrorMessage
                  component='div'
                  name='status'
                  className='text-danger'
                />
              </div>
              <div className='form-group mt-3'>
                <label
                  htmlFor='reason'
                >
                  Reason
                </label>
                <Form.Control
                  name='reason'
                  type='text'
                  placeholder='Enter Reason'
                  value={values.reason}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={touched.reason && errors.reason ? 'border border-danger' : ''}
                />
                <ErrorMessage
                  component='div'
                  name='reason'
                  className='text-danger'
                />
              </div>
            </Modal.Body>
            <div className='mt-4 '>
              <Modal.Footer className='d-flex justify-content-between align-items-center'>
                <Button
                  variant='outline-warning'
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant='outline-success'
                  onClick={handleSubmit}
                  className='ml-2'
                >
                  Submit
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        )}

      </Formik>
    </>
  )
}

export default AffiliateApprovalRejectionForm
